<div class="modal-header">
  <h4 class="modal-title">{{(isTemplate ? 'MODAL_CLONE.TEMPLATE.TITLE' : 'MODAL_CLONE.SESSION.TITLE') | translate}}</h4>
  <button (click)="activeModal.dismiss()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<form (ngSubmit)="cloneSession()" [formGroup]="form">
  <div class="modal-body">
    <div class="form-group">
      <input #sessionName
             (keyup)="checkLength()"
             aria-describedby="sessionNameHelp"
             class="form-control"
             formControlName="sessionName"
             id="sessionNameInput"
             placeholder="{{(isTemplate ? 'MODAL_CLONE.TEMPLATE.INPUT' : 'MODAL_CLONE.SESSION.INPUT') | translate}}"
             type="text">
      <div *ngIf="!sessionName.valid">
        <small
          *ngIf="(sessionName.dirty || sessionName.touched) && sessionName.hasError('required')"
          class="text-danger form-text">
          {{(isTemplate ? 'MODAL_CLONE.TEMPLATE.ERRORS.INVALID_REQUIRED' : 'MODAL_CLONE.SESSION.ERRORS.INVALID_REQUIRED') | translate}}
        </small>
        <small
          *ngIf="showLengthError"
          class="text-danger form-text">
          {{(isTemplate ? 'MODAL_CLONE.TEMPLATE.ERRORS.INVALID_MAX_LENGTH' : 'MODAL_CLONE.SESSION.ERRORS.INVALID_MAX_LENGTH') | translate}}
        </small>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button (click)="activeModal.dismiss()" class="btn btn-outline-secondary"
            type="button">{{(isTemplate ? 'MODAL_CLONE.TEMPLATE.CANCEL' : 'MODAL_CLONE.SESSION.CANCEL') | translate}}</button>
    <button [disabled]="submitted || form.invalid" class="btn btn-primary"
            type="submit">{{(isTemplate ? 'MODAL_CLONE.TEMPLATE.SUBMIT' : 'MODAL_CLONE.SESSION.SUBMIT') | translate}}</button>
  </div>
</form>
